import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TgSettingsService } from 'app/services/TG-Setting_Services/tg-settings.service';
import { ShowPartialJobDetailsFieldsPipe } from '../../../Common/pipes/show-partial-job-details-fields.pipe';
import * as _ from 'lodash';

declare var $: any;

@Component({
  selector: 'app-job-navigation',
  standalone: true,
  imports: [CommonModule, TranslateModule, ShowPartialJobDetailsFieldsPipe],
  templateUrl: './job-navigation.component.html',
  styleUrl: './job-navigation.component.scss'
})
export class JobNavigationComponent implements OnInit {

  tgSettings: any = {};
  prevJob: any = null;
  nextJob: any = null;
  bJDScroll: boolean = false;
  enableSocialReferral: boolean = false;
  jobDetailFields: any = {};
  JobFieldsToDisplay:any;

  @Output() onJobNavigate = new EventEmitter<{ job: any, direction: string }>();

  @Input() set navigationParams(val: any) {
      if (val) {
          this.prevJob = val.prevJob;
          this.nextJob = val.nextJob;
          this.bJDScroll = val.bJDScroll;
          this.jobDetailFields = val.jobDetailFields;
          this.JobFieldsToDisplay = this.tgSettingsService.getSearchResJobFieldsToDisplay() || [];
      }
  }

  constructor(private tgSettingsService: TgSettingsService) {}

  ngOnInit(): void {
    this.tgSettings = this.tgSettingsService.getCurrentSettings()?.tgSettings;
    this.JobFieldsToDisplay = this.tgSettingsService.getSearchResJobFieldsToDisplay() || [];
    this.bJDScroll = this.tgSettings?.['JDScrollEnabled'].toLowerCase();
    this.enableSocialReferral = this.tgSettings?.['EnableSocialReferral'].toLowerCase();
  }

  jobNextPrevHot(scope: any, param: any) {
    param = param + "Job";
    if (!scope[param] || !scope[param].Questions) return false;
    return _.map(_.filter(scope[param].Questions, { "QuestionName": "hotjob" }), "Value").toString().toLowerCase() == "yes";
  }

  jobDetailsSlide(job: any, val: any) {
    var reqId = _.find(job.Questions, { QuestionName: "reqid" })?.Value || "";
    $("#PartialApplyQuestions").css("display", "none");
    $("#applyFromDetailBtnSlide").animate({ right: "-42px" }, 500, "easeInSine");

    if (this.bJDScroll && job != "") {
        var jobdata = job;
        var myval = val;
        var jobTitle = _.map(_.filter(job.Questions, { "QuestionName": "jobtitle" }), "Value").toString();
        this.prevJob = null;
        this.nextJob = null;
        this.jobDetailFields.slide = false;
        //this.jobDetailFields.slideAlert = this.dynamicStrings.Lbl_JDScrollStateChange.replace("[jobid]", jobTitle);

        if (myval == 'next') {
            $(".jobDetailsLiner").removeClass('nga-squash-left-add').addClass('nga-squash-right-add');
        } else {
            $(".jobDetailsLiner").removeClass('nga-squash-right-add').addClass('nga-squash-left-add');
        }

        // Emit to parent instead of doing AJAX call here
        this.onJobNavigate.emit({ job: job, direction: val });
    }
  }

}
